import React, { useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import {
  Box,
  FormControl,
  Modal,
  Input,
  InputLabel,
  InputAdornment,
  IconButton,
  TextField,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
} from "@mui/material";
import IconUI from "../components/ui/icon_ui";
import {
  AiOutlineUserAdd,
  AiOutlineEdit,
  AiOutlineCheck,
} from "react-icons/ai";
import { FcCancel } from "react-icons/fc";
import MUIDataTable from "mui-datatables";
import { services } from "../services/api";
import { NotificacionContext } from "../context/notificacion_context";
import CapturaContext from "../context/captura_context/capturaContext";
import KeyIcon from "@mui/icons-material/Key";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import swal from "sweetalert";
import { maxLengthLimitInput } from "../utils/inputsRules";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import GifLoader from "../components/ui/gifLoader";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

const options = {
  selectableRows: false,
  tableBodyHeight: "auto",
  textLabels: {
    body: {
      noMatch: "Lo sentimos, no hay coincidencias en la busqueda",
      toolTip: "Clasificar",
      columnHeaderTooltip: (column) => `Clasificar por ${column.label}`,
    },
    pagination: {
      next: "Siguiente",
      previous: "Anterior",
      rowsPerPage: "Filas por página:",
      displayRows: "de",
    },
    toolbar: {
      search: "Buscar",
      downloadCsv: "Descargar CSV",
      print: "Imprimir",
      viewColumns: "Ver columnas",
      filterTable: "Filtrar tabla",
    },
    filter: {
      all: "Todo",
      title: "Filtros",
      reset: "Restaurar",
    },
    viewColumns: {
      title: "Ver columnas",
      titleAria: "Mostrar/Ocultar columnas en la tabla",
    },
    selectedRows: {
      text: "columna(s) selecciona(as)",
      delete: "Eliminar",
      deleteAria: "Eliminar filas seleccionadas",
    },
  },
  responsive: "standard",
  downloadOptions: {
    filename: "tablaUsuarios.csv",
    filterOptions: {
      useDisplayedColumnsOnly: false,
      useDisplayedRowsOnly: false,
    },
  },
  overrides: {
    MuiTableCell: {
      head: {
        backgroundColor: "#7c858c !important",
      },
    },
  },
};

const CrudUsers = (props) => {
  const colorUI = "#6f1d46";
  const { deletDatosTabla } = useContext(CapturaContext);

  const { showNotification } = useContext(NotificacionContext);

  const [modalShow, setModalShow] = useState({
    modalPinpad: false,
    modalPagosEfectivo: false,
  });

  const [userSelected, setUserSelected] = useState("");
  const [credentialsPinPad, setCredentialsPinPad] = useState({
    user_id: "",
    convenio: "",
    password: "",
    usuario: "",
    urlPINPAD: "",
    Ambiente: "",
    operationType: "",
  });

  const [pagosEfectivo, setPagosEfectivo] = useState({
    userId: "",
    bancoId: "",
    convenio: "",
    sufijo: "",
    bancosData: [],
    cobro: false,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loader, setloader] = useState(false);

  const rolUser = localStorage.getItem("rol");

  // const [state, setState] = useState({
  //   loading: false,
  // });

  const styleModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };

  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#005cbf"),
    backgroundColor: colorUI,
    "&:hover": {
      backgroundColor: colorUI,
    },
  }));

  const closeModal = (boolean, optionModal) => {
    setModalShow({ ...modalShow, [optionModal]: boolean });
  };

  const habilitarUser = async (body) => {
    let eliminarUsuario = await services(
      "DELETE",
      `usuarios/eliminar/${body.curp}`
    );
    if (eliminarUsuario.status === 200) {
      showNotification(
        "success",
        "Acción Exitosa!",
        "La operación se realizó correctamente",
        null,
        4
      );
      deletDatosTabla(eliminarUsuario.data);
    } else {
      showNotification(
        "error",
        "Acción No Exitosa!",
        "La operación no se realizó correctamente",
        null,
        4
      );
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const isObjectEmpty = (obj) => {
    for (let key in obj) {
      if (obj[key] === "" || obj[key] === null || obj[key] === undefined) {
        return true;
      }
    }
    return false;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    let newValue = value;

    if (name === "nombreBanco") {
      newValue = value.replace(/[^a-zA-Z0-9\s]/g, "").slice(0, 30);
    } else if (name === "convenio") {
      newValue = value.replace(/\D/g, "").slice(0, 30);
    } else if (name === "sufijo") {
      newValue = value.replace(/\D/g, "").slice(0, 2);
    } else if (type === "checkbox") {
      newValue = checked;
    }

    setPagosEfectivo({
      ...pagosEfectivo,
      [name]: newValue,
    });
  };

  // Metodo asignar credenciales PINPAD
  const assingCredentials = async () => {
    swal({
      title: "Atención",
      text: "¿Las credenciales son correctas?",
      icon: "info",
      buttons: ["Cancelar", "Aceptar"],
      confirmButton: true,
    }).then(async (result) => {
      if (result) {
        const asignCredentials = await services(
          "PUT",
          `usuarios/pinpad`,
          credentialsPinPad
        );

        if (asignCredentials.status === 200) {
          swal({
            title: "¡Éxito!",
            text: "Asignación de credenciales correcta",
            icon: "success",
            button: "Aceptar",
          }).then(() => {
            closeModal();
          });
          document.querySelector(
            ".swal-button--confirm"
          ).style.backgroundColor = colorUI;
        } else {
          swal({
            title: "Error",
            text:
              asignCredentials.data.error !== null
                ? asignCredentials.data.error
                : "No se han podido asignar las credenciales",
            icon: "error",
            button: "Aceptar",
          }).then(() => {
            closeModal(false, "modalPinpad");
          });
          document.querySelector(
            ".swal-button--confirm"
          ).style.backgroundColor = colorUI;
          return;
        }
      } else {
        return;
      }
    });
    document.querySelector(".swal-button--confirm").style.backgroundColor =
      colorUI;
  };

  // Metodo para cargar credenciales PINPAD
  const credentialsData = async (curp) => {
    const resCredentials = await services("GET", `usuarios/getPinpad/${curp}`);
    if (resCredentials.status !== 200) {
      showNotification(
        "error",
        "Error al consultar la información",
        resCredentials.data.error,
        null,
        4
      );
    }
    return resCredentials.data ? resCredentials.data : {};
  };

  const getDataPagos = async (id) => {
    setloader(true);

    closeModal(true, "modalPagosEfectivo");

    const response = await services("GET", `usuario/${id}/cajaChica`);

    if (response.status === 200) {
      setPagosEfectivo({
        ...pagosEfectivo,
        bancosData: response.data.bancos,
        userId: id,
        bancoId: response.data.user.bancoId,
        convenio: response.data.user.convenioCajaChica,
        sufijo: response.data.user.sufjio,
        cobro: response.data.user.cajaChica,
      });
    } else {
      showNotification(
        "error",
        "Error",
        "Ocurrio un error al obtener los datos",
        null,
        4
      );
    }
    setloader(false);
  };

  const sendDataPagosEfectivo = async () => {
    setloader(true);

    const bodyCajaChica = {
      bancoId: pagosEfectivo.bancoId,
      convenioCajaChica: pagosEfectivo.convenio,
      sufijo: pagosEfectivo.sufijo,
      cajaChica: pagosEfectivo.cobro === true ? 1 : 0,
    };

    const response = await services(
      "PUT",
      `usuario/${pagosEfectivo.userId}/cajaChica`,
      bodyCajaChica
    );

    if (response.status === 200) {
      showNotification("success", "Operación éxitosa", "", null, 4);
    } else {
      showNotification(
        "error",
        "Error",
        "Ocurrio un error al asignar habilitar los pagos en línea",
        null,
        4
      );
    }
    setPagosEfectivo({
      ...pagosEfectivo,
      bancoId: "",
      convenio: "",
      sufijo: "",
      bancosData: [],
      cobro: false,
    });
    closeModal(false, "modalPagosEfectivo");
    setloader(false);
  };

  const columns = [
    {
      name: "curp",
      label: "CURP",
      align: "center",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, i) => {
          let curp = props.dataUsers[dataIndex].curp;
          return (
            <div
              style={{ height: "60px" }}
              className={
                i % 2 === 0
                  ? "bg-rosaClaro d-flex align-items-center justify-content-center"
                  : "d-flex align-items-center justify-content-center"
              }
            >
              {curp}
            </div>
          );
        },
      },
    },
    {
      name: "nombre",
      label: "Nombre",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, i) => {
          let nombre = props.dataUsers[dataIndex].nombre;
          return (
            <div
              style={{ height: "60px" }}
              className={
                i % 2 === 0
                  ? "bg-rosaClaro d-flex align-items-center justify-content-center"
                  : "d-flex align-items-center justify-content-center"
              }
            >
              {nombre}
            </div>
          );
        },
      },
    },
    {
      name: "primerApellido",
      label: "Apellido Paterno",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, i) => {
          let primerApellido = props.dataUsers[dataIndex].primerApellido;
          return (
            <div
              style={{ height: "60px" }}
              className={
                i % 2 === 0
                  ? "bg-rosaClaro d-flex align-items-center justify-content-center"
                  : "d-flex align-items-center justify-content-center"
              }
            >
              {primerApellido}
            </div>
          );
        },
      },
    },
    {
      name: "segundoApellido",
      label: "Apellido Materno",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, i) => {
          let segundoApellido = props.dataUsers[dataIndex].segundoApellido;
          return (
            <div
              style={{ height: "60px" }}
              className={
                i % 2 === 0
                  ? "bg-rosaClaro d-flex align-items-center justify-content-center"
                  : "d-flex align-items-center justify-content-center"
              }
            >
              {segundoApellido}
            </div>
          );
        },
      },
    },
    {
      name: "rol",
      label: "Rol",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, i) => {
          let rol = props.dataUsers[dataIndex].rol;
          return (
            <div
              style={{ height: "60px" }}
              className={
                i % 2 === 0
                  ? "bg-rosaClaro d-flex align-items-center justify-content-center"
                  : "d-flex align-items-center justify-content-center"
              }
            >
              {rol}
            </div>
          );
        },
      },
    },
    {
      name: "area",
      label: "Área",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, i) => {
          const area = props.dataUsers[dataIndex].area;
          return (
            <div
              style={{ height: "60px" }}
              className={
                i % 2 === 0
                  ? "bg-rosaClaro d-flex align-items-center justify-content-center"
                  : "d-flex align-items-center justify-content-center"
              }
            >
              {area}
            </div>
          );
        },
      },
    },
    {
      name: "fechaBaja",
      label: "Fecha Baja",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, i) => {
          let val = props.dataUsers[dataIndex].fechaBaja;
          return (
            <div
              style={{ height: "60px" }}
              className={
                i % 2 === 0
                  ? "bg-rosaClaro  d-flex align-items-center justify-content-center"
                  : " d-flex align-items-center justify-content-center"
              }
            >
              {val === null ? "N/A" : val}
            </div>
          );
        },
      },
    },
    {
      name: "acciones",
      label: "Acciones",
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex, i) => (
          <>
            {props.dataUsers[dataIndex].fechaBaja === null ? (
              <div
                style={{ height: "60px" }}
                className={
                  i % 2 === 0
                    ? "w-100 d-flex align-items-center justify-content-center bg-rosaClaro "
                    : "w-100 d-flex justify-content-center align-items-center "
                }
              >
                {props.dataUsers[dataIndex].rol === "Ventanilla" &&
                  props.dataUsers[dataIndex].pinpad === 1 &&
                  (rolUser === "Administrador" ||
                    rolUser !== "adminDependencia") ? (
                  <div
                    style={{ height: 30, width: 30, zIndex: 0 }}
                    className="cta cta--primary cta--icon icon_btn me-1"
                    onClick={() => {
                      const getData = async () => {
                        setloader(true);

                        let userData = props.dataUsers[dataIndex].curp;
                        let userId = props.dataUsers[dataIndex].id;
                        const {
                          ambiente_pinpad,
                          convenio_pinpad,
                          operationType_pinpad,
                          url_pinpad,
                          usuario_pinpad,
                        } = await credentialsData(userData);

                        setCredentialsPinPad(() => ({
                          user_id: userId,
                          convenio: convenio_pinpad,
                          usuario: usuario_pinpad,
                          urlPINPAD: url_pinpad,
                          Ambiente: ambiente_pinpad,
                          operationType: operationType_pinpad,
                        }));

                        setloader(false);
                        setUserSelected(userData);
                        closeModal(true, "modalPinpad");
                      };
                      getData();
                    }}
                  >
                    <IconUI size={"20px"} color={"white"}>
                      <KeyIcon />
                    </IconUI>
                    <div className="icon_btn_help">
                      Asignar credenciales de PinPad
                    </div>
                  </div>
                ) : null}

                {/* PAGO EN EFECTIVO */}
                {props.dataUsers[dataIndex].rol === "Ventanilla" &&
                  (rolUser === "Administrador" ||
                    (rolUser === "adminDependencia" && rolUser !== "adminDependencia")) ? (
                  <div
                    onClick={() => {
                      let userData = props.dataUsers[dataIndex].curp;
                      let userId = props.dataUsers[dataIndex].id;

                      setUserSelected(userData);
                      getDataPagos(userId);
                    }}
                    style={{ height: 30, width: 30, zIndex: 0 }}
                    className="cta cta--primary cta--icon icon_btn me-1"
                  >
                    <IconUI size={"20px"} color={"white"}>
                      <AttachMoneyIcon />
                    </IconUI>
                    <div className="icon_btn_help">
                      Asignar credenciales pago en efectivo
                    </div>
                  </div>
                ) : null}

                <div
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn"
                  onClick={() => {
                    let bodyUpdate = {
                      curp: props.dataUsers[dataIndex].curp,
                      email: props.dataUsers[dataIndex].email,
                      fechaBaja: props.dataUsers[dataIndex].fechaBaja,
                      id: props.dataUsers[dataIndex].id,
                      id_municipio: props.dataUsers[dataIndex].id_municipio,
                      id_oficina: props.dataUsers[dataIndex].id_oficina,
                      nombre: props.dataUsers[dataIndex].nombre,
                      primerApellido: props.dataUsers[dataIndex].primerApellido,
                      rol: props.dataUsers[dataIndex].rol,
                      segundoApellido:
                        props.dataUsers[dataIndex].segundoApellido,
                      area: props.dataUsers[dataIndex].area,
                      id_dependencia: props.dataUsers[dataIndex].id_dependencia,
                      nombre_dependencia:
                        props.dataUsers[dataIndex].nombre_dependencia,
                    };

                    props.showPopUpUpdateOnView(bodyUpdate);
                  }}
                >
                  <IconUI size={"20px"} color={"white"}>
                    <AiOutlineEdit />
                  </IconUI>
                  <div className="icon_btn_help">Editar</div>
                </div>
                <div
                  style={{ height: 30, width: 30, zIndex: 0, marginLeft: 5 }}
                  className="cta cta--warning cta--icon icon_btn"
                  onClick={() => {
                    showNotification(
                      "option",
                      "¿Estás seguro de realizar esta acción?",
                      "Al dar click en Aceptar se inhabilitará este usuario",
                      () => {
                        let body = {
                          curp: props.dataUsers[dataIndex].curp,
                        };
                        habilitarUser(body);
                      },
                      null
                    );
                  }}
                >
                  <IconUI size={"20px"} color={"black"}>
                    <FcCancel />
                  </IconUI>
                  <div className="icon_btn_help">Bloquear</div>
                </div>
              </div>
            ) : (
              <div
                className={
                  i % 2 === 0
                    ? "w-100 d-flex justify-content-center p-3 bg-rosaClaro"
                    : "w-100 d-flex justify-content-center p-3"
                }
              >
                <div
                  style={{ height: 30, width: 30, zIndex: 0, marginLeft: 5 }}
                  className="cta cta--success cta--icon icon_btn"
                  onClick={() => {
                    showNotification(
                      "option",
                      "¿Estás seguro de realizar esta acción?",
                      "Al dar click en Aceptar se habilitará este usuario",
                      () => {
                        let body = {
                          curp: props.dataUsers[dataIndex].curp,
                        };
                        habilitarUser(body);
                      },
                      null
                    );
                  }}
                >
                  <IconUI size={"15px"} color={"white"}>
                    <AiOutlineCheck />
                  </IconUI>
                  <div className="icon_btn_help">Desbloquear</div>
                </div>
              </div>
            )}
          </>
        ),
      },
    },
  ];

  return (
    <>
      {/* {state.loading ? <GifLoader /> : null} */}
      {loader ? <GifLoader /> : null}
      <div className="container">
        <Grid sx={{ marginTop: 3 }} container spacing={2}>
          <Grid align="center" item xs={12} sm={6} md={6}></Grid>
          <Grid align="right" item xs={12} sm={6} md={6}>
            <div
              style={{ width: 200 }}
              className="cta cta--guinda"
              onClick={() => {
                props.showPopUpOnView();
              }}
            >
              <div className="me-2">
                <IconUI size={"20px"} color={"white"}>
                  <AiOutlineUserAdd />
                </IconUI>
              </div>{" "}
              Nuevo Usuario
            </div>
          </Grid>
        </Grid>
      </div>

      <Box>
        <Grid className="my-5 mx-4">
          <Grid item xs={8}>
            <MUIDataTable
              style={{ Overflow: "hidden" }}
              title={"Usuarios del Sistema"}
              data={props.dataUsers ?? []}
              columns={columns}
              options={options}
            />
          </Grid>
        </Grid>
      </Box>

      {/* Modal asignar credenciales PINPAD*/}
      <Modal
        open={modalShow.modalPinpad}
        onClose={() => closeModal(false, "modalPinpad")}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          <h2 className="mb-4 text-center">
            Asignar credenciales de <strong>PinPad</strong> para el usuario{" "}
            <strong className="d-none d-md-block">{userSelected}</strong>
          </h2>
          <h3 className="d-md-none">
            <strong>{userSelected}</strong>
          </h3>

          <Grid align="right" item xs={12} sm={6} md={3}>
            <FormControl sx={{ marginTop: 3, width: "100%" }}>
              <InputLabel htmlFor="my-input">Convenio</InputLabel>
              <Input
                fullWidth
                value={credentialsPinPad.convenio}
                onChange={(e) => {
                  setCredentialsPinPad({
                    ...credentialsPinPad,
                    convenio: e.target.value,
                  });
                }}
                onKeyPress={(event) => {
                  maxLengthLimitInput(event, 30, "convenio");
                }}
                id="convenio"
                name="convenio"
                aria-describedby="my-helper-text"
                required
              />
            </FormControl>
          </Grid>
          <Grid align="right" item xs={12} sm={6} md={3}>
            <FormControl sx={{ marginTop: 3, width: "100%" }}>
              <InputLabel htmlFor="my-input">Usuario</InputLabel>
              <Input
                fullWidth
                value={credentialsPinPad.usuario}
                onChange={(e) => {
                  setCredentialsPinPad({
                    ...credentialsPinPad,
                    usuario: e.target.value,
                  });
                }}
                id="usuario"
                name="usuario"
                aria-describedby="my-helper-text"
                required
              />
            </FormControl>
          </Grid>
          <Grid align="right" item xs={12} sm={6} md={3}>
            <FormControl sx={{ marginTop: 3, width: "100%" }}>
              <InputLabel htmlFor="passwordUser">Contraseña</InputLabel>
              <Input
                fullWidth
                type={showPassword ? "text" : "password"}
                value={credentialsPinPad.password}
                onChange={(e) => {
                  setCredentialsPinPad({
                    ...credentialsPinPad,
                    password: e.target.value,
                  });
                }}
                onKeyPress={(event) => {
                  maxLengthLimitInput(event, 30, "passwordUser");
                }}
                id="passwordUser"
                name="passwordUser"
                aria-describedby="my-helper-text"
                required
                endAdornment={
                  <InputAdornment className="me-2" position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
          <Grid align="right" item xs={12} sm={6} md={3}>
            <FormControl sx={{ marginTop: 3, width: "100%" }}>
              <InputLabel htmlFor="my-input">URL de la Pinpad</InputLabel>
              <Input
                fullWidth
                value={credentialsPinPad.urlPINPAD}
                onChange={(e) => {
                  setCredentialsPinPad({
                    ...credentialsPinPad,
                    urlPINPAD: e.target.value,
                  });
                }}
                // onKeyPress={(event) => {
                //   maxLengthLimitInput(event, 30, "usuario");
                // }}
                id="usuario"
                name="usuario"
                aria-describedby="my-helper-text"
                required
              />
            </FormControl>
          </Grid>
          <Grid align="right" item xs={12} sm={6} md={3}>
            <FormControl sx={{ marginTop: 3, width: "100%" }}>
              <InputLabel htmlFor="my-input">Ambiente</InputLabel>
              <Input
                fullWidth
                value={credentialsPinPad.Ambiente}
                onChange={(e) => {
                  setCredentialsPinPad({
                    ...credentialsPinPad,
                    Ambiente: e.target.value,
                  });
                }}
                id="usuario"
                name="usuario"
                aria-describedby="my-helper-text"
                required
              />
            </FormControl>
          </Grid>
          <Grid align="right" item xs={12} sm={6} md={3}>
            <FormControl sx={{ marginTop: 3, marginBottom: 8, width: "100%" }}>
              <InputLabel htmlFor="my-input">Tipo de operación</InputLabel>
              <Input
                fullWidth
                value={credentialsPinPad.operationType}
                onChange={(e) => {
                  setCredentialsPinPad({
                    ...credentialsPinPad,
                    operationType: e.target.value,
                  });
                }}
                onKeyPress={(event) => {
                  maxLengthLimitInput(event, 30, "usuario");
                }}
                id="usuario"
                name="usuario"
                aria-describedby="my-helper-text"
                required
              />
            </FormControl>
          </Grid>

          <div className="d-flex flex-column-reverse flex-md-row gap-3 gap-md-0 justify-content-between">
            <ColorButton
              className="bg-danger"
              variant="outlined"
              onClick={() => closeModal(false, "modalPinpad")}
            >
              Cerrar
            </ColorButton>
            <ColorButton
              variant="outlined"
              onClick={() => {
                if (isObjectEmpty(credentialsPinPad)) {
                  swal({
                    title: "Campos requeridos",
                    text: "Por favor, llena todos los campos requeridos",
                    icon: "info",
                    button: "Aceptar",
                  }).then(() => { });
                  document.querySelector(
                    ".swal-button--confirm"
                  ).style.backgroundColor = colorUI;
                  return;
                }
                assingCredentials();
              }}
            >
              Asignar
              <IconUI size={"20px"} color={"white"}>
                <KeyIcon className="ms-1" />
              </IconUI>
            </ColorButton>
          </div>
        </Box>
      </Modal>

      {/* Modal permitir pagos en efectivo*/}
      <Modal
        open={modalShow.modalPagosEfectivo}
        onClose={() => {
          closeModal(false, "pagosEfectivo");
          setPagosEfectivo({
            ...pagosEfectivo,
            bancoId: "",
            convenio: "",
            sufijo: "",
            bancosData: [],
            cobro: false,
          });
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          <h2 className="mb-4 text-center">
            Asignar pagos en efectivo al usuario con curp:
            <strong className="d-none d-md-block">{userSelected}</strong>
          </h2>

          <div className="d-flex flex-column gap-4 mb-2">
            <FormControl variant="standard">
              <InputLabel id="demo-simple-select-standard-label">
                Nombre del banco
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                name="bancoId"
                value={pagosEfectivo.bancoId}
                onChange={handleChange}
                label="Nombre del banco"
              >
                {pagosEfectivo?.bancosData.map((ele) => (
                  <MenuItem key={ele?.id} value={ele?.id}>
                    {ele?.nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              id="standard-basic"
              name="convenio"
              onChange={handleChange}
              value={pagosEfectivo.convenio}
              label="Convenio"
              variant="standard"
            />

            <TextField
              id="standard-basic"
              name="sufijo"
              onChange={handleChange}
              value={pagosEfectivo.sufijo}
              label="Sufijo"
              variant="standard"
            />

            <FormControlLabel
              checked={pagosEfectivo.cobro}
              className="float-end"
              name="cobro"
              value={pagosEfectivo.cobro}
              onChange={handleChange}
              control={<Checkbox defaultChecked />}
              label="Cobro"
            />
          </div>

          <div className="d-flex flex-column-reverse flex-md-row gap-3 gap-md-0 justify-content-between">
            <ColorButton
              className="bg-danger"
              variant="outlined"
              onClick={() => {
                closeModal(false, "modalPagosEfectivo");

                setPagosEfectivo({
                  ...pagosEfectivo,
                  bancoId: "",
                  convenio: "",
                  sufijo: "",
                  bancosData: [],
                  cobro: false,
                });
              }}
            >
              Cerrar
            </ColorButton>
            <ColorButton
              variant="outlined"
              onClick={() => {
                sendDataPagosEfectivo();
              }}
            >
              Guardar
            </ColorButton>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default CrudUsers;
